/* Auto-generated. Do not edit manually. */
import { ReactComponent as Block_1_100 } from "../blocks/1/land_plot_block_100.svg";
import { ReactComponent as Block_1_101 } from "../blocks/1/land_plot_block_101.svg";
import { ReactComponent as Block_1_102 } from "../blocks/1/land_plot_block_102.svg";
import { ReactComponent as Block_1_103 } from "../blocks/1/land_plot_block_103.svg";
import { ReactComponent as Block_1_104 } from "../blocks/1/land_plot_block_104.svg";
import { ReactComponent as Block_1_105 } from "../blocks/1/land_plot_block_105.svg";
import { ReactComponent as Block_1_106 } from "../blocks/1/land_plot_block_106.svg";
import { ReactComponent as Block_1_107 } from "../blocks/1/land_plot_block_107.svg";
import { ReactComponent as Block_1_108 } from "../blocks/1/land_plot_block_108.svg";
import { ReactComponent as Block_1_109 } from "../blocks/1/land_plot_block_109.svg";
import { ReactComponent as Block_1_110 } from "../blocks/1/land_plot_block_110.svg";
import { ReactComponent as Block_1_93 } from "../blocks/1/land_plot_block_93.svg";
import { ReactComponent as Block_1_94 } from "../blocks/1/land_plot_block_94.svg";
import { ReactComponent as Block_1_95 } from "../blocks/1/land_plot_block_95.svg";
import { ReactComponent as Block_1_96 } from "../blocks/1/land_plot_block_96.svg";
import { ReactComponent as Block_1_97 } from "../blocks/1/land_plot_block_97.svg";
import { ReactComponent as Block_1_98 } from "../blocks/1/land_plot_block_98.svg";
import { ReactComponent as Block_1_99 } from "../blocks/1/land_plot_block_99.svg";
import { ReactComponent as Block_31_100 } from "../blocks/31/land_plot_block_100.svg";
import { ReactComponent as Block_31_101 } from "../blocks/31/land_plot_block_101.svg";
import { ReactComponent as Block_31_102 } from "../blocks/31/land_plot_block_102.svg";
import { ReactComponent as Block_31_103 } from "../blocks/31/land_plot_block_103.svg";
import { ReactComponent as Block_31_104 } from "../blocks/31/land_plot_block_104.svg";
import { ReactComponent as Block_31_105 } from "../blocks/31/land_plot_block_105.svg";
import { ReactComponent as Block_31_106 } from "../blocks/31/land_plot_block_106.svg";
import { ReactComponent as Block_31_107 } from "../blocks/31/land_plot_block_107.svg";
import { ReactComponent as Block_31_108 } from "../blocks/31/land_plot_block_108.svg";
import { ReactComponent as Block_31_109 } from "../blocks/31/land_plot_block_109.svg";
import { ReactComponent as Block_31_110 } from "../blocks/31/land_plot_block_110.svg";
import { ReactComponent as Block_31_93 } from "../blocks/31/land_plot_block_93.svg";
import { ReactComponent as Block_31_94 } from "../blocks/31/land_plot_block_94.svg";
import { ReactComponent as Block_31_95 } from "../blocks/31/land_plot_block_95.svg";
import { ReactComponent as Block_31_96 } from "../blocks/31/land_plot_block_96.svg";
import { ReactComponent as Block_31_97 } from "../blocks/31/land_plot_block_97.svg";
import { ReactComponent as Block_31_98 } from "../blocks/31/land_plot_block_98.svg";
import { ReactComponent as Block_31_99 } from "../blocks/31/land_plot_block_99.svg";
import { ReactComponent as Block_61_100 } from "../blocks/61/land_plot_block_100.svg";
import { ReactComponent as Block_61_101 } from "../blocks/61/land_plot_block_101.svg";
import { ReactComponent as Block_61_102 } from "../blocks/61/land_plot_block_102.svg";
import { ReactComponent as Block_61_103 } from "../blocks/61/land_plot_block_103.svg";
import { ReactComponent as Block_61_104 } from "../blocks/61/land_plot_block_104.svg";
import { ReactComponent as Block_61_105 } from "../blocks/61/land_plot_block_105.svg";
import { ReactComponent as Block_61_106 } from "../blocks/61/land_plot_block_106.svg";
import { ReactComponent as Block_61_107 } from "../blocks/61/land_plot_block_107.svg";
import { ReactComponent as Block_61_108 } from "../blocks/61/land_plot_block_108.svg";
import { ReactComponent as Block_61_109 } from "../blocks/61/land_plot_block_109.svg";
import { ReactComponent as Block_61_110 } from "../blocks/61/land_plot_block_110.svg";
import { ReactComponent as Block_61_93 } from "../blocks/61/land_plot_block_93.svg";
import { ReactComponent as Block_61_94 } from "../blocks/61/land_plot_block_94.svg";
import { ReactComponent as Block_61_95 } from "../blocks/61/land_plot_block_95.svg";
import { ReactComponent as Block_61_96 } from "../blocks/61/land_plot_block_96.svg";
import { ReactComponent as Block_61_97 } from "../blocks/61/land_plot_block_97.svg";
import { ReactComponent as Block_61_98 } from "../blocks/61/land_plot_block_98.svg";
import { ReactComponent as Block_61_99 } from "../blocks/61/land_plot_block_99.svg";
import { ReactComponent as Block_90_100 } from "../blocks/90/land_plot_block_100.svg";
import { ReactComponent as Block_90_101 } from "../blocks/90/land_plot_block_101.svg";
import { ReactComponent as Block_90_102 } from "../blocks/90/land_plot_block_102.svg";
import { ReactComponent as Block_90_103 } from "../blocks/90/land_plot_block_103.svg";
import { ReactComponent as Block_90_104 } from "../blocks/90/land_plot_block_104.svg";
import { ReactComponent as Block_90_105 } from "../blocks/90/land_plot_block_105.svg";
import { ReactComponent as Block_90_106 } from "../blocks/90/land_plot_block_106.svg";
import { ReactComponent as Block_90_107 } from "../blocks/90/land_plot_block_107.svg";
import { ReactComponent as Block_90_108 } from "../blocks/90/land_plot_block_108.svg";
import { ReactComponent as Block_90_109 } from "../blocks/90/land_plot_block_109.svg";
import { ReactComponent as Block_90_110 } from "../blocks/90/land_plot_block_110.svg";
import { ReactComponent as Block_90_93 } from "../blocks/90/land_plot_block_93.svg";
import { ReactComponent as Block_90_94 } from "../blocks/90/land_plot_block_94.svg";
import { ReactComponent as Block_90_95 } from "../blocks/90/land_plot_block_95.svg";
import { ReactComponent as Block_90_96 } from "../blocks/90/land_plot_block_96.svg";
import { ReactComponent as Block_90_97 } from "../blocks/90/land_plot_block_97.svg";
import { ReactComponent as Block_90_98 } from "../blocks/90/land_plot_block_98.svg";
import { ReactComponent as Block_90_99 } from "../blocks/90/land_plot_block_99.svg";

export const zone3_block_polygons = [
    {
        wrapperIndex: 2,
        areas: [
            {
                blockIndex: 93,
                Polygon: Block_1_93,
            },
            {
                blockIndex: 94,
                Polygon: Block_1_94,
            },
            {
                blockIndex: 95,
                Polygon: Block_1_95,
            },
            {
                blockIndex: 96,
                Polygon: Block_1_96,
            },
            {
                blockIndex: 97,
                Polygon: Block_1_97,
            },
            {
                blockIndex: 98,
                Polygon: Block_1_98,
            },
            {
                blockIndex: 99,
                Polygon: Block_1_99,
            },
            {
                blockIndex: 100,
                Polygon: Block_1_100,
            },
            {
                blockIndex: 101,
                Polygon: Block_1_101,
            },
            {
                blockIndex: 102,
                Polygon: Block_1_102,
            },
            {
                blockIndex: 103,
                Polygon: Block_1_103,
            },
            {
                blockIndex: 104,
                Polygon: Block_1_104,
            },
            {
                blockIndex: 105,
                Polygon: Block_1_105,
            },
            {
                blockIndex: 106,
                Polygon: Block_1_106,
            },
            {
                blockIndex: 107,
                Polygon: Block_1_107,
            },
            {
                blockIndex: 108,
                Polygon: Block_1_108,
            },
            {
                blockIndex: 109,
                Polygon: Block_1_109,
            },
            {
                blockIndex: 110,
                Polygon: Block_1_110,
            },
        ],
    },
    {
        wrapperIndex: 32,
        areas: [
            {
                blockIndex: 93,
                Polygon: Block_31_93,
            },
            {
                blockIndex: 94,
                Polygon: Block_31_94,
            },
            {
                blockIndex: 95,
                Polygon: Block_31_95,
            },
            {
                blockIndex: 96,
                Polygon: Block_31_96,
            },
            {
                blockIndex: 97,
                Polygon: Block_31_97,
            },
            {
                blockIndex: 98,
                Polygon: Block_31_98,
            },
            {
                blockIndex: 99,
                Polygon: Block_31_99,
            },
            {
                blockIndex: 100,
                Polygon: Block_31_100,
            },
            {
                blockIndex: 101,
                Polygon: Block_31_101,
            },
            {
                blockIndex: 102,
                Polygon: Block_31_102,
            },
            {
                blockIndex: 103,
                Polygon: Block_31_103,
            },
            {
                blockIndex: 104,
                Polygon: Block_31_104,
            },
            {
                blockIndex: 105,
                Polygon: Block_31_105,
            },
            {
                blockIndex: 106,
                Polygon: Block_31_106,
            },
            {
                blockIndex: 107,
                Polygon: Block_31_107,
            },
            {
                blockIndex: 108,
                Polygon: Block_31_108,
            },
            {
                blockIndex: 109,
                Polygon: Block_31_109,
            },
            {
                blockIndex: 110,
                Polygon: Block_31_110,
            },
        ],
    },
    {
        wrapperIndex: 62,
        areas: [
            {
                blockIndex: 93,
                Polygon: Block_61_93,
            },
            {
                blockIndex: 94,
                Polygon: Block_61_94,
            },
            {
                blockIndex: 95,
                Polygon: Block_61_95,
            },
            {
                blockIndex: 96,
                Polygon: Block_61_96,
            },
            {
                blockIndex: 97,
                Polygon: Block_61_97,
            },
            {
                blockIndex: 98,
                Polygon: Block_61_98,
            },
            {
                blockIndex: 99,
                Polygon: Block_61_99,
            },
            {
                blockIndex: 100,
                Polygon: Block_61_100,
            },
            {
                blockIndex: 101,
                Polygon: Block_61_101,
            },
            {
                blockIndex: 102,
                Polygon: Block_61_102,
            },
            {
                blockIndex: 103,
                Polygon: Block_61_103,
            },
            {
                blockIndex: 104,
                Polygon: Block_61_104,
            },
            {
                blockIndex: 105,
                Polygon: Block_61_105,
            },
            {
                blockIndex: 106,
                Polygon: Block_61_106,
            },
            {
                blockIndex: 107,
                Polygon: Block_61_107,
            },
            {
                blockIndex: 108,
                Polygon: Block_61_108,
            },
            {
                blockIndex: 109,
                Polygon: Block_61_109,
            },
            {
                blockIndex: 110,
                Polygon: Block_61_110,
            },
        ],
    },
    {
        wrapperIndex: 91,
        areas: [
            {
                blockIndex: 93,
                Polygon: Block_90_93,
            },
            {
                blockIndex: 94,
                Polygon: Block_90_94,
            },
            {
                blockIndex: 95,
                Polygon: Block_90_95,
            },
            {
                blockIndex: 96,
                Polygon: Block_90_96,
            },
            {
                blockIndex: 97,
                Polygon: Block_90_97,
            },
            {
                blockIndex: 98,
                Polygon: Block_90_98,
            },
            {
                blockIndex: 99,
                Polygon: Block_90_99,
            },
            {
                blockIndex: 100,
                Polygon: Block_90_100,
            },
            {
                blockIndex: 101,
                Polygon: Block_90_101,
            },
            {
                blockIndex: 102,
                Polygon: Block_90_102,
            },
            {
                blockIndex: 103,
                Polygon: Block_90_103,
            },
            {
                blockIndex: 104,
                Polygon: Block_90_104,
            },
            {
                blockIndex: 105,
                Polygon: Block_90_105,
            },
            {
                blockIndex: 106,
                Polygon: Block_90_106,
            },
            {
                blockIndex: 107,
                Polygon: Block_90_107,
            },
            {
                blockIndex: 108,
                Polygon: Block_90_108,
            },
            {
                blockIndex: 109,
                Polygon: Block_90_109,
            },
            {
                blockIndex: 110,
                Polygon: Block_90_110,
            },
        ],
    },
];